import cn from "classnames";
import React from "react";

const Avatar = ({ cname, imageUrl }) => {
    const style = imageUrl ? { backgroundImage: `url(${imageUrl})` } : {};
    const ownCname = cn({
        avatar: true,
        "avatar--url": !!imageUrl,
        [cname]: !!cname,
    });
    return <div className={ownCname} style={style} />;
};

export default Avatar;
